/**
 * Store MailsTypes
 */
export default {
    state: {
        mailsTypes: [],
        statutMailConfirmation: 3,
        statutMailRelance: 4,
        statutMailComplet: 6,
        statutMailTvaRemboursement: 7,
        statutMailTvaAPayer: 8,
        statutMailComptesAnnuels: 9,
        statutMailLettreAccueil: 12,
    },
    
    mutations: {
        /**
         * Initialise le state mailsTypes
         */
        setMailsTypes: function (state, mailsTypes) {
            state.mailsTypes = mailsTypes
        }
    },

    actions: {
        saveMailType: function (context, payload) {
            axios.request({
                url: '/api/mails-types' + (payload.mailType.id ? '/' + payload.mailType.id : ''),
                method: payload.mailType.id ? 'patch' : 'post',
                data: payload.mailType
            }).then(() => {
                payload.successFunction()
            }).catch(error => {
                payload.errorFunction(error)
            }).finally(() => {
                payload.finallyFunction()
                context.dispatch('init')
            })
        },
    },

    getters: {
        /**
         * Liste d'options des types de mails
         */
        optionsMailsTypes: state => {
            return state.mailsTypes.map(type => {
                return {label: type.nom, value: type.id, objet: type.objet, contenu: type.contenu}
            })
        }
    }
}
